export function useLoginStore() {
  var _useNuxt2App = useNuxt2App(),
    app = _useNuxt2App.app;
  var nextRoutePath = useState("login-data-next-route-path", function () {
    return app.localePath({
      name: 'my-account'
    });
  });
  var previousRoutePath = useState("login-data-previous-route-path", function () {
    return null;
  });
  function storeNextRoutePath(routePath) {
    if (!routePath) {
      return;
    }
    nextRoutePath.value = routePath;
  }
  function storePreviousRoutePath(routePath) {
    previousRoutePath.value = routePath;
  }
  return {
    nextRoutePath: readonly(nextRoutePath),
    previousRoutePath: readonly(previousRoutePath),
    storePreviousRoutePath: storePreviousRoutePath,
    storeNextRoutePath: storeNextRoutePath
  };
}